import { Directive, ElementRef, HostListener, forwardRef } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TwoDecimalNumberDirective),
  multi: true,
};

@Directive({
  selector: '[appTwoDigitDecimaNumber]',
  providers: [INPUT_CONTROL_VALUE_ACCESSOR],
})
export class TwoDecimalNumberDirective implements ControlValueAccessor {
  // Allow decimal numbers and negative values
  private regex = new RegExp(/^-?\d*\.?\d{0,2}$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  private onChange: (arg0: any) => void;
  private onTouch: (arg0: any) => void;

  constructor(private el: ElementRef) {}
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      ((event.ctrlKey === true || event.metaKey == true) && ['C', 'c', 'V', 'v', 'X', 'x', 'A', 'a', 'Z', 'z'].indexOf(event.key) !== -1)
    ) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' || event.key == '.' ? '.' : event.key, current.slice(position)].join('');

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

  //Handle paste value, as keydown event don't track paste value.
  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this.el.nativeElement.value;
    let val = initalValue ? initalValue.replaceAll(',', '') : '';

    if (event.inputType == 'insertFromPaste') {
      val = parseFloat(val);
      const splitText = val ? val.toString().split('.') : '';
      if (splitText.length > 1 && splitText[1].length > 1) {
        val = Number(val).toFixed(2);
      }
      this.el.nativeElement.value = val;

      if (initalValue !== this.el.nativeElement.value) {
        event.stopPropagation();
      }
    }

    this.onChange(val);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(newValue) {
    newValue = newValue == null ? '' : newValue;
    this.el.nativeElement.value = newValue;
  }
}
